import React from 'react';
import { Link } from 'react-router-dom';
import { posts } from '../blog';
import { PostList } from '../blog/PostList';
import type { LinkComponent } from '../blog/LinkComponent';
import { BLOG_DESCRIPTION, BLOG_TITLE, blogJsonLd, blogUrl } from '../blog/seo';
import { useHead } from '../lib/useHead';

const RouterLink: LinkComponent = ({ to, className, children }) => (
  <Link to={to} className={className}>
    {children}
  </Link>
);

const Blog: React.FC = () => {
  useHead({
    title: `${BLOG_TITLE} | Guides for home cooks`,
    description: BLOG_DESCRIPTION,
    canonical: blogUrl(),
    jsonLd: blogJsonLd(posts),
  });

  return <PostList posts={posts} Link={RouterLink} />;
};

export default Blog;
